<template>
  <v-row justify="end">
    <v-dialog v-model="dialog" persistent max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn dark icon class="position-absolute image-badge" v-on="on">
          <v-icon id="settingId" color="#344452">
            mdi-square-edit-outline
          </v-icon>
        </v-btn>
      </template>
      <v-card class="dialog-cls">
        <v-card-title class="profile-title pb-4">
          Profile Picture
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="py-5">
          <vue-dropzone
            ref="myVueDropzone"
            id="dropzone"
            :destroyDropzone="false"
            :options="dropzoneOptions"
            @vdropzone-sending="beforecomplete"
            @vdropzone-success="aftercomplete"
            @vdropzone-mounted="uploadedImage"
            @vdropzone-removed-file="removeFile"
            class="useravtar-image"
          ></vue-dropzone>
        </v-card-text>
        <v-card-actions v-if="media.length > 0" class="justify-center">
          <v-btn class="btn-style" color="error" @click.prevent="deleteImage">
            <v-icon>mdi mdi-delete</v-icon> Remove
          </v-btn>
          <v-btn class="btn-style" color="primary" @click="changeImage">
            <v-icon class="mdi mdi-image" /> Change
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import store from "@/store";
import { ProfileService } from "@/services";

export default {
  name: "UploadAvtar",
  components: {
    vueDropzone: vue2Dropzone
  },
  props: {
    media: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialog: false,
      files: [],
      dropzoneOptions: {
        url: `${process.env.VUE_APP_SERVERURL}media`,
        chunking: true,
        // addRemoveLinks: true,
        // autoProcessQueue: true,
        maxFilesize: 1,
        maxFiles: 1,
        dictFileTooBig:
          "File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        init() {
          this.on("maxfilesexceeded", function(file) {
            this.removeAllFiles();
            this.addFile(file);
          });
          this.on("addedfile", file => {
            if (file.size > 1024 * 1024 * 1) {
              // not more than 1mb
              this.removeFile(file);
            }
          });
        },
        headers: {
          Authorization: `Bearer ${store.state.user.token}`
        },
        acceptedFiles: "image/*"
      }
    };
  },
  methods: {
    beforecomplete(file, xhr, formData) {
      this.$refs.myVueDropzone.removeEventListeners();
      formData.append("mediaType", "image");
      formData.append("moduleType", "user");
      formData.append("mediaSubType", "file");
      formData.append("moduleId", store.state.user.user._id);
    },
    aftercomplete(file, response) {
      this.dialog = false;
      this.$refs.myVueDropzone.setupEventListeners();
      this.$emit("profileUrl", response);
      this.$store.dispatch("user/setSnack", "Image uploaded");
      this.$store.dispatch("user/setType", "info");
    },
    uploadedImage() {
      if (this.media && this.media.length > 0) {
        var file = {
          size: this.media[0].size,
          name: this.media[0].name,
          type: this.media[0].type
        };
        this.$refs.myVueDropzone.manuallyAddFile(file, this.media[0].url);
      }
    },
    changeImage() {
      document.getElementById("dropzone").click();
    },
    deleteImage() {
      this.$refs.myVueDropzone.removeAllFiles();
      this.$emit("removeProfile");
      this.dialog = false;
      this.$store.dispatch("user/setSnack", "Image deleted");
      this.$store.dispatch("user/setType", "info");
    },

    removeFile(file) {
      if (file.size > 1024 * 1024 * 1) {
        this.$store.dispatch(
          "user/setSnack",
          "Upto 1 MB Image size is allowed"
        );
        this.$store.dispatch("user/setType", "error");
      }
      this.deletePicture();
    },
    async deletePicture() {
      this.media.forEach(async media => {
        if (!this.files.includes(media._id)) {
          this.files.push(media._id);
          const response = await ProfileService.removeProfileImage({
            id: media._id,
            data: {
              moduleType: "user",
              moduleId: store.state.user.user._id
            }
          });
          if (response) {
            this.$emit("removeProfile");
          }
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.v-list-item {
  .list-item {
    font-family: Palanquin;
    font-style: normal;
    font-size: 15px;
    line-height: 130%;
    color: #313131;
    letter-spacing: 0.05em;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
  }
  min-height: 32px;
}
.vue-dropzone {
  text-align: center;
}
.image-badge {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 20;
}
.position-absolute {
  position: absolute;
}
.v-btn--icon.v-size--default .v-icon,
.v-btn--fab.v-size--default .v-icon {
  height: 30px;
  font-size: 20px;
  width: 30px;
  color: #fff !important;
  background-color: #096dd8;
  border-radius: 50%;
  border: 2px solid #fff;
}
.profile-title {
  font-family: "Now Alt";
  font-style: normal;
  font-size: 22px;
  color: #0c1f36;
  font-weight: 500;
}
.btn-style {
  text-transform: capitalize;
}
</style>
